/**
 * Returns the FY label for a given date, e.g. "2026-27".
 * FY starts in April (month 4).
 */
export function getFYLabel(dateStr) {
  const d = new Date(dateStr);
  const month = d.getMonth() + 1;
  const year = d.getFullYear();
  const fyStartYear = month >= 4 ? year : year - 1;
  const endYearShort = String(fyStartYear + 1).slice(-2);
  return `${fyStartYear}-${endYearShort}`;
}

/**
 * Returns the current financial year label, e.g. "2026-27".
 */
export function getCurrentFY() {
  return getFYLabel(new Date());
}

/**
 * Returns an array of 3 FY labels centered on the given FY: [fy-1, fy, fy+1].
 */
export function getAdjacentFYs(fyLabel) {
  const startYear = parseInt(fyLabel.split('-')[0]);
  return [-1, 0, 1].map(offset => {
    const y = startYear + offset;
    return `${y}-${String(y + 1).slice(-2)}`;
  });
}
